<script lang="ts">
    import { ComponentPublicInstance } from 'vue';
    import { JSX } from 'vue/jsx-runtime';

    const component = {
        name: 'Button_Fluid',
    };

    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const props = defineProps<{
        click?: () => void;
        text?: string;
        icon?: JSX.Element | ComponentPublicInstance;
        iconClasses?: string;
        textStyles?: { [key: string]: string } | string;
        textClasses?: string;
        iconProps?: any;
    }>();
</script>

<template>
    <button type="button" class="fluid-button">
        <span class="button-wrapper">
            <component v-if="icon" :is="icon" v-bind="iconProps" class="button-icon" :class="iconClasses"></component>
            <span class="fw600" :class="textClasses" :style="textStyles">{{ text }}</span>
        </span>
    </button>
</template>

<style lang="less">
    .fluid-button.icon-simple {
        width: auto;
        border-radius: 2px;
    }

    .fluid-button.icon-simple svg {
        padding: 0.75rem;
    }

    .fluid-button svg {
        width: 0.875rem;
        height: 0.875rem;
    }

    .fluid-button svg.md {
        width: 1.125rem;
        height: 1.125rem;
    }

    .fluid-button svg.lg {
        width: 1.375rem;
        height: 1.375rem;
    }

    .fluid-button {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        user-select: none;
        white-space: nowrap;
        cursor: pointer;
    }

    div.fluid-button.fw {
        max-width: unset;
    }

    .button-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }

    .button-icon {
        opacity: 0.85;
        transition-property: opacity;
        transition-duration: var(--td-faster);
        transition-timing-function: ease;
    }

    .fluid-button:hover .button-icon {
        opacity: 1;
    }

    .button-container {
        display: flex;
        align-items: center;
        padding: 0 0.6rem;
    }

    .button-container .fluid-button {
        margin: 1rem 0;
    }

    .button-container .fluid-button:not(:first-child) {
        margin-left: 0.5rem;
    }

    .fluid-button.text-button {
        height: 1.75rem;
        border-radius: 0.2rem;
        opacity: 0.7;
        transition: opacity 0.3s ease;
    }

    .fluid-button.text-button:hover {
        background-color: transparent;
        opacity: 1;
        cursor: pointer;
    }

    .fluid-button.column .button-wrapper {
        flex-direction: column;
        white-space: normal;
        text-align: center;
    }
</style>
